<form>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showAvatar">
         <input
            type="checkbox"
            id="showAvatar"
            [checked]="showAvatar$ | async"
            (click)="changeShowAvatar($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.agent_details.settings.show_avatar' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showCaller">
         <input
            type="checkbox"
            id="showCaller"
            [checked]="showCaller$ | async"
            (click)="changeShowCaller($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.agent_details.settings.show_caller' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showSkills">
         <input
            type="checkbox"
            id="showSkills"
            [checked]="showSkills$ | async"
            (click)="changeShowSkills($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.agent_details.settings.show_skills' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showGroups">
         <input
            type="checkbox"
            id="showGroups"
            [checked]="showGroups$ | async"
            (click)="changeShowGroups($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.agent_details.settings.show_groups' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showCallHistory">
         <input
            type="checkbox"
            id="showCallHistory"
            [checked]="showCallHistory$ | async"
            (click)="changeShowCallHistory($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.agent_details.settings.show_call_history' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label>{{
         'brick.brick_definitions.agent_details.settings.num_of_call_history_entries_to_show' | translate
      }}</label>
      <kendo-numerictextbox
         class="k-form-field sam-form-control sam-form-control-full-width"
         [value]="numEntriesOfCallHistoryToShow$ | async"
         [min]="0"
         [max]="100"
         format="n0"
         (valueChange)="changeNumOfCallHistoryEntriesToShow($event)"
      ></kendo-numerictextbox>
   </div>
</form>
